<template>
  <div class="price-groups-settings">
    <div class="qrw-heading-md">
      {{ $t("modificators_settings.title") }}
    </div>

    <SinglePriceGroupPanel
      v-for="(pg, pgi) in dish.price_groups"
      :key="pgi"
      :price_group="pg"
      :price_group_index="pgi"
    />

    <BasePushButton
      @click="addModificatorGroup"
      icon="plus"
      class="add-group-btn"
      size="sm"
      variant="outlined"
      borderColor="border-base-primary"
      textColor="content-base-primary"
    >
      {{ $t("modificators_settings.add_group") }}
    </BasePushButton>
  </div>
</template>

<script>
import SinglePriceGroupPanel from "@/components/menu/SinglePriceGroupPanel.vue";

export default {
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
  },
  methods: {
    addModificatorGroup() {
      this.$store.commit("menu/addPriceGroup", {
        name: null,
        single_select: true,
        max_count: 1,
        min_count: 1,
        items: [
          {
            name: null,
            price: null,
            weight: null,
            stock: true,
          },
        ],
      });

      this.$nextTick(() => {
        if (this.dish.price_groups.length > 2) {
          window.scrollTo(0, document.body.scrollHeight);
        }
      });
    },
  },
  components: {
    SinglePriceGroupPanel,
  },
};
</script>

<style scoped>
.price-groups-settings {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.add-group-btn {
  width: fit-content;
  justify-self: center;
  align-self: center;
}
</style>
